module.exports = __webpack_public_path__ + "img/resource@2x.9c2e869c.png";